<template>
  <div>
    <div class="is-print-hide">
      <el-table
        stripe
        :data="tableData"
        row-key="id"
        size="medium"
        header-row-class-name="common-table-header"
        row-class-name="common-table-row"
        class="is-print-hide common-table"
        :border="true"
      >
        <el-table-column prop="storeNo" label="门店编号" min-width="107">
          <template slot="header" slot-scope="scope">
            <div class="hname">
              门店编号
            </div>
          </template>
          <template slot-scope="scope">
            <div class="storeNo_box">
              <div class="tag" v-if="scope.row.disableStatus == 1">
                <img :src="require('@/assets/img/disabledTag.png')" alt="" />
              </div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.storeNo" placement="top">
                <span> {{ scope.row.storeNo }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="门店名称" min-width="163">
          <template slot-scope="scope">
            <div class="storename_cell">
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.name" placement="top">
                <span> {{ scope.row.name }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shopManager" label="店长" min-width="66">
          <template slot-scope="scope">
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                :open-delay="500"
                :content="
                  (scope.row.shopManager && scope.row.shopManager.name) || (scope.row.shopManager && scope.row.shopManager.mobile)
                "
                placement="top"
              >
                <span v-if="scope.row.shopManager"> {{ genshopManager(scope.row.shopManager) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态" min-width="80" v-if="tableShow()">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="renderText(scope.row.status)" placement="top">
                <span> {{ renderText(scope.row.status) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" min-width="80">
          <template slot="header" slot-scope="scope">
            <div class="hnamecenter">
              操作
            </div>
          </template>
          <template slot-scope="scope">
            <el-row>
              <div class="handler">
                <div class="btn global_common_text_hover" v-if="renderDel(scope)" @click="reopen(scope.row.id)">
                  <span>开启</span>
                </div>
              </div>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Button,
  Input,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Row,
  Tooltip,
  Checkbox,
  CheckboxGroup
} from 'element-ui';
import Vue from 'vue';
import noDataMode from '@/components/global/table/noDataMode';
import { hasPermission } from '@/util/index';
import Constant from '@/lib/constant';
import { dataDesensitization } from '@fastweb/f2e-utils';
const baseRole = Constant.RoleList;
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Button);
Vue.use(Input);
Vue.use(Row);
Vue.use(Tooltip);
export default {
  name: 'shopManagementTable',
  props: ['tableData'],

  data() {
    return {
      printImg: '',
      pcListConfig: {
        dispense: false,
        dispatch: false
      },
      dataModeShow: false,
      checked: false,
      checkList: ['选中且禁用', '复选框 A']
    };
  },
  watch: {},
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    reopen(id) {
      const storeId = id;
      const _this = this;
      // 删除该门店
      this.$confirm(`确定启用该药店吗`, `启用药店`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        customClass: 'confirm',
        center: true,
        callback(action) {
          if (action == 'confirm') {
            Fetch.recover_store({ storeId })
              .then(res => {
                _this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success'
                });
                _this.$emit('delItem', storeId);
              })
              .catch(e => {
                console.log(e);
              });
          }
        }
      });
    },
    renderDel() {
      // 渲染删除按钮
      let per = [baseRole.a];
      if (hasPermission(per)) {
        return true;
      } else {
        return false;
      }
    },
    genshopManager(data) {
      // 渲染店长
      if (data.name) {
        return data.name;
      } else {
        if (data.mobile) {
          return dataDesensitization(data.mobile);
        }
        return '';
      }
    },
    tableShow() {
      let per = [baseRole.a, baseRole.c, baseRole.d];
      if (hasPermission(per)) {
        return true;
      } else {
        return false;
      }
    },
    editShow(scope) {
      // 编辑按钮显示逻辑
      let per = [baseRole.a, baseRole.c, baseRole.d];
      if (hasPermission(per)) {
        if (scope.row.status == -1) {
          return true;
        }
      }
    },

    renderText(st) {
      // 根据状态渲染文字
      if (st == 0) {
        return '待审核';
      }
      if (st == 1) {
        return '已审核';
      }
      if (st == -1) {
        return '重新认证';
      }
    },
    editorShop(id) {
      this.$router.push('/shopManagement/editorShop/' + id);
    },
    showShop(id) {
      this.$router.push('/shopManagement/showShop/' + id);
    }
  }
};
</script>

<style lang="scss">
.unselect .el-checkbox {
  // display: none;
}
</style>
<style lang="scss" scoped>
.handler {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .btn {
    font-size: 12px;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
}

.addressText {
  width: 241px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.remotePharmacistRow {
  overflow: hidden;
  .row_check {
    float: left;
  }
  .row_tex {
    margin-left: 35px;
    float: left;
    max-width: 100px;
  }
}
.table_header {
  overflow: hidden;
  padding: 0;
  line-height: normal;
  width: 100%;
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  // padding-top: 20px;
  // line-height: 30px;
  .table_header_text {
    float: left;
  }
}

.tag {
  position: absolute;
  left: 0;
  top: 0;
  img {
    display: block;
    width: 28px;
  }
}
.hname {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  padding-left: 2px;
}
.hnamecenter {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}
.storename_cell {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
